import { ProductLineV1 } from './product-line';

export interface ProductLineResponse {
  links: [
    {
      href: string
      rel: string
      method: string
    }
  ];
  count: number;
  totalCount: number;
  productLines: ProductLineV1[];
}
